import { render, staticRenderFns } from "./PhotoBook.vue?vue&type=template&id=befa15dc&scoped=true&"
import script from "./PhotoBook.vue?vue&type=script&lang=js&"
export * from "./PhotoBook.vue?vue&type=script&lang=js&"
import style0 from "./PhotoBook.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PhotoBook.vue?vue&type=style&index=1&id=befa15dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befa15dc",
  null
  
)

export default component.exports